import { AuthenticationStrategy } from '@shared/interfaces/authentication-strategies.interface';
import { AuthContext } from '@shared/interfaces/auth-context.interface';
import {
  SessionRestoreStrategyConfig,
} from '@shared/services/session-restore-strategy/session-restore-strategy.config';
import { SessionStorageService } from '@nequi/design-system-lib/logic';
import Keycloak from 'keycloak-js';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';
import { saveTokens } from '@shared/utils/keycloak-token/keycloak-token';
import { KeycloakErrorHandler } from '@shared/services/keycloak-error-handler/keycloak-error-handler.service';

export class SessionRestoreStrategy implements AuthenticationStrategy {
  public canHandle(context: AuthContext): boolean {
    return !!context.sessionStorage.getItem(SessionRestoreStrategyConfig.keycloakStorage.kcToken);
  }

  public async execute(context: AuthContext): Promise<boolean> {
    return await this.tryRestoreSession(context.sessionStorage);
  }

  private async tryRestoreSession(
    sessionStorageService: SessionStorageService,
  ): Promise<boolean> {
    const keycloak: Keycloak = getKeycloakInstance();
    const savedToken: string = sessionStorageService.getItem(SessionRestoreStrategyConfig.keycloakStorage.kcToken) as string;
    const savedRefresh: string = sessionStorageService.getItem(SessionRestoreStrategyConfig.keycloakStorage.kcRefreshToken) as string;

    if (!savedToken || !savedRefresh) return false;

    keycloak.token = savedToken;
    keycloak.refreshToken = savedRefresh;

    try {
      await keycloak.updateToken(SessionRestoreStrategyConfig.minValidity);
      saveTokens(sessionStorageService);
      return true;
    } catch (err) {
      KeycloakErrorHandler.handle(err, SessionRestoreStrategyConfig.errorInit.token);
      return false;
    }
  }
}
